import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IPartnerGroupInfo } from 'legacy/lut/classes/models/partner360/IPartnerGroup'

import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

export const fetchPartnerGroups = async (
  pid: string,
  forceFetch?: boolean
): Promise<IPartnerGroupInfo[]> => {
  const crud = CrudStore.get(CrudStoreItemPartner360.JBPPartnerGroupInfo, 'getPartnerGroup')
  crud.setDefaultFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'PartnerId',
        operator: Operator.EQUAL,
        value: pid,
      },
    ],
  })

  const res = await crud.fetch({ force: forceFetch })
  return res.items
}
